export enum Language {
    EN = "EN",
    DE = "DE"
}

export const Languages: Language[] = [
    Language.EN, Language.DE
]

export function fromString(value: string): Language {
    return Language[value.toUpperCase().split('-')[0] as keyof typeof Language];
}

export function toString(language: Language): string {
    let ret = "";
    switch (language) {
        case Language.EN: ret = "en"; break;
        case Language.DE: ret = "de"; break;
    }
    //console.log('toString',ret);
    return ret;
}

export function languageToString(languages: any): Language[] {
    //console.log(languages);
    const array: Language[] = [];
    (languages as []).forEach((language: string) => array.push(fromString(language)));
    return array;
}